import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Aug 14 2018
 * @author SKu
 */
import { Uppy } from '@uppy/core';
import Dashboard from '@uppy/react/lib/Dashboard';
import * as React from 'react';
import { debugEnabled } from '../../../shared/logger/debugEnabled';
import FileUploaderStyled from './styled/FileUploaderStyled';
import withValidation from '../withValidation';
/**
 * Create component that allow upload files
 * [See DOCS for uppy](https://uppy.io/)
 */

var FileUploader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(FileUploader, _React$PureComponent);

  function FileUploader() {
    var _this;

    _classCallCheck(this, FileUploader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileUploader).apply(this, arguments));
    _this.uppy = new Uppy({
      autoProceed: false,
      id: _this.props.id,
      debug: debugEnabled(),
      restrictions: Object.assign({
        maxFileSize: null,
        maxNumberOfFiles: 1,
        minNumberOfFiles: null,
        allowedFileTypes: null
      }, _this.props.restrictions)
    });
    return _this;
  }

  _createClass(FileUploader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.events.forEach(function (event) {
        _this2.uppy.on(event.key, event.action);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      this.props.events.forEach(function (event) {
        _this3.uppy.off(event.key, event.action);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(FileUploaderStyled, {
        className: "relative uppy-container"
      }, React.createElement(Dashboard, Object.assign({}, this.props, {
        uppy: this.uppy,
        inline: false,
        hideUploadButton: true,
        disableStatusBar: true,
        disableInformer: true,
        proudlyDisplayPoweredByUppy: false,
        closeModalOnClickOutside: false
      })), this.props.progress);
    }
  }]);

  return FileUploader;
}(React.PureComponent);

export default FileUploader;
export var FileUploaderValidated = withValidation(FileUploader);